module.exports = __webpack_public_path__ + "static/media/newBrandpetroteclogo.d34ce2bb.png";